import React, { Fragment, PureComponent } from 'react';
import OurVideosList from './OurVideosList.jsx';
import ChevronDown from 'react-feather/dist/icons/chevron-down.js';
import ChevronUp from 'react-feather/dist/icons/chevron-up.js';

export default class OurVideosItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isDeployed: false,
    };
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    this.checkAnchor();
  }

  checkAnchor = () => {
    const anchor = window.location.hash.replace('#', '');
    if (anchor === this.props.item.id) {
      this.setState({ isDeployed: true }, () => {
        setTimeout(() => {
          if (this.containerRef.current) {
            this.containerRef.current.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }, 100);
      });
    }
  };

  render() {
    const { item, index, currentPlayingId, handlePlay, handlePause } = this.props;
    const { isDeployed } = this.state;

    return (
      <div
        id={item.id}
        ref={this.containerRef}
        className={`our-videos-item ${index % 2 === 0 ? `bg-light` : ''}`}
      >
        <div className="container py-5">
          {item.title ? (
            <h2
              className="d-flex mb-0 align-items-center align-items-md-start"
              onClick={() => this.setState({ isDeployed: !isDeployed })}
            >
              {item.title}
              <span className="ml-2 ml-md-4">
                {isDeployed ? <ChevronUp size={36} /> : <ChevronDown size={36} />}
              </span>
            </h2>
          ) : null}

          {isDeployed ? (
            <Fragment>
              {item.description ? (
                <p
                  className="mt-3"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              ) : null}

              <OurVideosList
                videos={item.videos}
                currentPlayingId={currentPlayingId}
                onPlay={handlePlay}
                onPause={handlePause}
              />
            </Fragment>
          ) : null}
        </div>
      </div>
    );
  }
}
